import { render, staticRenderFns } from "./UnitDetail.vue?vue&type=template&id=52c39012&scoped=true&"
import script from "./UnitDetail.vue?vue&type=script&lang=js&"
export * from "./UnitDetail.vue?vue&type=script&lang=js&"
import style0 from "./UnitDetail.vue?vue&type=style&index=0&id=52c39012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c39012",
  null
  
)

export default component.exports